/*
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-21 13:39:20
 * @LastEditors: 牛字杰 niuzijie@.jtexpress
 * @LastEditTime: 2022-07-21 13:58:56
 * @FilePath: \yl-wxcx-coupon-front\src\utils\loadScript.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export function loadScript (url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.onload = () => resolve()

    script.onerror = () => reject(new Error(`Load script from ${url} failed`))

    script.src = url
    const head =
        document.head || document.getElementsByTagName('head')[0]
      ;(document.body || head).appendChild(script)
  })
}
